<template>
  <div>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
      <span class="wf-w-1/2 wf-text-xs wf-tracking-wide wf-font-light wf-lowercase">style</span>
      <div class="wf-flex wf-w-1/2">
        <select class="wf-w-full" name="source_options" v-model="style">
          <option value="DOTS_ROUNDED">Rounded</option>
          <option value="DOTS_SQUARE">Square</option>
          <option value="DOTS_LINE">Line</option>
        </select>
      </div>
    </li>
  </div>
</template>

<script>
  import {CarouselDotsClasses} from '../classes/CarouselDotsClasses'
  import MenuStyleProperty from '../contracts/MenuStyleProperty'
  export default MenuStyleProperty.extend({
    computed: {
      styleClasses() {
        return Object.keys(CarouselDotsClasses)
      },
      style: {
        get() {
          let currentStyle = this.elementClasses(this.classes)[this.device].find(elementClass => this.styleClasses.includes(elementClass.value))
          if (! currentStyle) {
            currentStyle = {property: 'CarouselDots', value: 'DOTS_ROUNDED', touched: false}
            this.addToArray(this.module, [currentStyle], this.classes, this.device, {}, true, this.parentModule)
          }
          return currentStyle.value
        },
        set(value) {
          let currentStyle = this.elementClasses(this.classes)[this.device].find(elementClass => this.styleClasses.includes(elementClass.value))
          this.removeFromArray(this.module, [currentStyle], this.classes, this.device, {}, true, this.parentModule)
          value = {property: 'CarouselDots', value: value, touched: currentStyle.touched}
          this.addToArray(this.module, [value], this.classes, this.device, {}, true, this.parentModule)
        }
      },
    }
  })
</script>